import debug from 'debug';
export const createLogger = (...namespace) => debug(`@interhyp/platform-tealium${namespace.length > 0 ? `:${namespace.join(':')}` : ''}`);